import { TableHeader } from 'components/Table/Table';
import { formatDate } from 'helpers/date';
import {
  Advertiser,
  BudgetType,
  Campaign,
} from '../MerchantOffers/MerchantOffer.types';

type InsertionOrder = {
  uuid: string;
  ticket: string;
  createdAt: Date;
};

type Adjustments = {
  adjustmentId: string;
  adjustmentName: string;
  adjustmentAmount: number;
  adjustmentCurrency: string;
  adjustmentApprovalDate: Date;
  adjustmentCreatedAt: Date;
  insertionOrder: InsertionOrder;
};

type Budget = {
  uuid: string;
  type: BudgetType;
  advertiser: Advertiser;
  createdAt: Date;
  totalBudget: number;
  currency: string;
  adjustments: Adjustments;
  balance: number;
};

type AdjustBudgetRequest = {
  budgetUuid: string;
  insertionOrderRef: string;
  amount: number;
  budgetAdjustmentName: string;
  approvalDate: Date;
};

type AdjustBudgetResult = {
  budgetAdjustmentId: number;
  request: AdjustBudgetRequest;
};

type CampaignSummary = {
  campaign: Campaign;
  advertiser: Advertiser;
  insertionOrder: InsertionOrder;
  budgets: [Budget];
};

const getTableHeader = (): TableHeader[] => [
  {
    source: ['campaign', 'name'],
    label: 'Campaign Name',
    width: 'five',
  },
  {
    source: ['campaign', 'startDate'],
    sortable: ['campaign', 'startDate'],
    label: 'Start Date',
    transform: (date: string) => formatDate(date, 'MMM DD, YYYY'),
    options: {
      class: 'dateLabel',
    },
  },
  {
    source: ['campaign', 'endDate'],
    sortable: ['campaign', 'endDate'],
    label: 'End Date',
    transform: (date: string) => formatDate(date, 'MMM DD, YYYY'),
    options: {
      class: 'dateLabel',
    },
  },
  {
    source: ['insertionOrder', 'ticket'],
    label: 'IO',
  },
  {
    source: ['advertiser', 'name'],
    label: 'Advertiser',
  },
  {
    source: ['budgets', '0', 'advertiser', 'type'],
    label: 'Budget Advertiser',
  },
  {
    source: ['budgets', '0', 'totalBudget'],
    label: 'Budget Amt',
    transform: (totalBudget: number) => `$${totalBudget}`,
    justify: 'right',
  },
  {
    source: ['budgets', '0', 'balance'],
    label: 'Budget Balance',
    transform: (balance: number) => `$${balance}`,
    justify: 'right',
  },
];

export {
  InsertionOrder,
  Adjustments,
  Budget,
  AdjustBudgetRequest,
  AdjustBudgetResult,
  CampaignSummary,
  getTableHeader,
};
